const getActions = {
    GET_EMAIL_TEMPLATE_START: "GET_EMAIL_TEMPLATE_START",
    GET_EMAIL_TEMPLATE_FAIL: "GET_EMAIL_TEMPLATE_FAIL",
    GET_EMAIL_TEMPLATE_SUCCESS: "GET_EMAIL_TEMPLATE_SUCCESS",
}

const getAllActions = {
    GET_ALL_EMAIL_TEMPLATES_START: "GET_ALL_EMAIL_TEMPLATES_START",
    GET_ALL_EMAIL_TEMPLATES_FAIL: "GET_ALL_EMAIL_TEMPLATES_FAIL",
    GET_ALL_EMAIL_TEMPLATES_SUCCESS: "GET_ALL_EMAIL_TEMPLATES_SUCCESS",
}

const patchActions = {
    PATCH_EMAIL_TEMPLATE_START: "PATCH_EMAIL_TEMPLATE_START",
    PATCH_EMAIL_TEMPLATE_FAIL: "PATCH_EMAIL_TEMPLATE_FAIL",
    PATCH_EMAIL_TEMPLATE_SUCCESS: "PATCH_EMAIL_TEMPLATE_SUCCESS",
}

const postActions = {
    POST_EMAIL_TEMPLATE_START: "POST_EMAIL_TEMPLATE_START",
    POST_EMAIL_TEMPLATE_FAIL: "POST_EMAIL_TEMPLATE_FAIL",
    POST_EMAIL_TEMPLATE_SUCCESS: "POST_EMAIL_TEMPLATE_SUCCESS",
}

const deleteActions = {
    DELETE_EMAIL_TEMPLATE_START: "DELETE_EMAIL_TEMPLATE_START",
    DELETE_EMAIL_TEMPLATE_FAIL: "DELETE_EMAIL_TEMPLATE_FAIL",
    DELETE_EMAIL_TEMPLATE_SUCCESS: "DELETE_EMAIL_TEMPLATE_SUCCESS",
}

const autosaveActions = {
    // AUTOSAVING
    AUTOSAVE_EMAIL_TEMPLATE_START: "AUTOSAVE_EMAIL_TEMPLATE_START",
    AUTOSAVE_EMAIL_TEMPLATE_BLOCKED: "AUTOSAVE_EMAIL_TEMPLATE_BLOCKED",
    AUTOSAVE_EMAIL_TEMPLATE_SUCCESS: "AUTOSAVE_EMAIL_TEMPLATE_SUCCESS",
}

const actionTypes = {
    UPDATE_EMAIL_TEMPLATE: "UPDATE_EMAIL_TEMPLATE",
    RESET_EMAIL_TEMPLATE: "RESET_EMAIL_TEMPLATE",
    RESET_REQUEST_ERROR: "RESET_REQUEST_ERROR",
    ...getActions,
    ...getAllActions,
    ...patchActions,
    ...postActions,
    ...deleteActions,
    ...autosaveActions,
}

export default actionTypes
